
import React, { useState, useRef, useEffect } from 'react';
import { useLocation, useHistory } from 'react-router-dom';
import BASE_URL from "components/BaseUrl/apiConfig";
import Navbar from 'components/Navbars/AuthNavbar'
import Footer from 'components/Footers/Footer'
import { useMediaQuery } from 'react-responsive';


const AddExpenseType = () => {

    const isLargeDevice = useMediaQuery({ minWidth: 1024 });

    const history = useHistory();
    const userNameInputRef = useRef(null);

    useEffect(() => {
        // Check if user is not logged in (localStorage is empty)
        if (!localStorage.getItem("userData")) {
            // Redirect to the login page
            history.push("/login");
        }
    }, [history]);



    const location = useLocation();

    const [expenseTypeData, setExpenseTypeData] = useState(null);


    useEffect(() => {
        // Focus on the userName input when the component mounts
        userNameInputRef.current.focus();
    }, []);

    useEffect(() => {
        // Check if data is available in the location state
        if (location.state && location.state.expenseType) {
            const { expenseType } = location.state;
            setFormData({
                expensedescTypeID: expenseType.expensedescTypeID || '',
                expenseTypeName: expenseType.expenseTypeName || '',
                defaultText: expenseType.defaulttext || '',
                type: expenseType.expenseTypeId || '',
            });
        }
    }, [location.state]);



    const [formData, setFormData] = useState({
        expenseTypeName: '',
        defaultText: '',
        type: '',
    });

    const [errors, setErrors] = useState({});


    //Get Useid form localStorage
    const storedUserData = localStorage.getItem('userData');
    let userId = '';

    if (storedUserData) {
        const userData = JSON.parse(storedUserData);
        userId = userData.userId;
    }

    const handleAddExpenseType = async (e) => {
        e.preventDefault();

        // Clear previous errors
        setErrors({});

        // Validate form data
        const validationErrors = {};

        if (!formData.expenseTypeName) {
            validationErrors.expenseTypeName = 'Expense Type  is required.';
        }

        if (!formData.type) {
            validationErrors.type = 'Select Type.';
        }

        if (Object.keys(validationErrors).length > 0) {
            // If there are validation errors, set the state and return
            setErrors(validationErrors);
            return;
        }

        try {
            debugger
            const url = location.state && location.state.expenseType
                ? `${BASE_URL}/api/ExpenseDescriptiontype/UpdateExpenseDescritionType`
                : `${BASE_URL}/api/ExpenseDescriptiontype/InsertExpenseDescritionType`;

            const response = await fetch(url, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    expensedescTypeID: formData.expensedescTypeID || null, // Include expensedescTypeID if present
                    expenseTypeName: formData.expenseTypeName,
                    defaulttext: formData.defaultText,
                    expenseTypeId: formData.type,
                    userId: userId,
                }),
            });

            if (response.ok) {
                history.push('/getExpensetype');
            } else {
                console.error('Error adding expense type');
            }
        } catch (error) {
            console.error('Error adding expense type:', error);
        }
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prevData) => ({
            ...prevData,
            [name]: value,
        }));
    };

    return (
        <>
            <Navbar />
            <div className='cust-div'>
                <div className="container mx-auto mt-8 p-4">
                    <form onSubmit={handleAddExpenseType} className="flex flex-wrap  p-4 rounded-lg shadow-lg bg-white">
                        <h1 className="text-2xl  font-bold mb-4">
                            {formData.expensedescTypeID ? 'Update Expense Type' : 'Add Expense Type'}
                            </h1>
                        <hr className="mt-6 border-b-1 border-blueGray-300" />
                        <div className="mb-4 w-full md:flex md:justify-between md:w-96 lg:w-120">
                            <div className="mb-4 md:w-1/3 pr-4">
                                <label htmlFor="expenseTypeName" className="block text-xs font-bold text-gray-700">
                                    Expense Type Name
                                </label>
                                <input
                                    type="text"
                                    id="expenseTypeName"
                                    name="expenseTypeName"
                                    maxLength={30}
                                    ref={userNameInputRef}
                                    value={formData.expenseTypeName}
                                    onChange={handleChange}
                                    placeholder='Expense Type Name'
                                    className="mt-1 p-2 border rounded w-full"
                                />
                                {/* here is the code of the expensedescTypeID store in hidden form */}
                                <input
                                    type="hidden"
                                    id="expensedescTypeID"
                                    name="expensedescTypeID"
                                    value={formData.expensedescTypeID}
                                />

                                {errors.expenseTypeName && (
                                    <p className="text-red-500 text-sm mt-1">{errors.expenseTypeName}</p>
                                )}
                            </div>

                            <div className="mb-4 md:w-1/3 pr-4">
                                <label htmlFor="defaultText" className="block text-xs font-bold text-gray-700">
                                    Default Text
                                </label>
                                {isLargeDevice ? (
                                    <input
                                        type="text"
                                        id="defaultText"
                                        maxLength={70}
                                        name="defaultText"
                                        value={formData.defaultText}
                                        onChange={handleChange}
                                        className="mt-1 p-2 border rounded"
                                        placeholder='Default Text'
                                        style={{ width: '785px' }}
                                    />
                                ) : (
                                    <input
                                        type="text"
                                        id="defaultText"
                                        maxLength={70}
                                        name="defaultText"
                                        value={formData.defaultText}
                                        onChange={handleChange}
                                        className="mt-1 p-2 border rounded-md w-full"
                                    />
                                )}
                            </div>

                            <div className="mb-4 md:w-1/3">
                                <label htmlFor="type" className="block text-xs font-bold text-gray-700">
                                    Type
                                </label>
                                <select
                                    id="type"
                                    name="type"
                                    value={formData.type}
                                    onChange={handleChange}
                                    className="mt-1 p-2 border rounded w-full"
                                    style={{ width: '150px' }}
                                >
                                    <option value="">Select Type</option>
                                    <option value="1">Credited</option>
                                    <option value="2">Debited</option>
                                </select>
                                {errors.type && (
                                    <p className="text-red-500 text-sm mt-1">{errors.type}</p>
                                )}
                            </div>
                        </div>

                        <div className="flex justify-end w-full">
                            <button type="button" className="bg-lightBlue-500 text-white active:bg-lightBlue-600 text-xs font-bold uppercase px-4 py-2 mr-4 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150" onClick={() => history.goBack()}>
                                Back To Expense Type List
                            </button>
                            <button type="submit" className="bg-blueGray-800 text-white active:bg-blueGray-600 text-sm font-bold uppercase px-3 py-2 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 sm:w-auto ease-linear transition-all duration-150">
                                {formData.expensedescTypeID ? 'Update Expense Type' : 'Add Expense Type'}
                            </button>

                        </div>
                    </form>
                </div>
            </div>
            <Footer />
        </>
    )
}

export default AddExpenseType
